// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-exact-active[data-v-7c2fb116]{color:var(--v-primary300-base)!important}", ""]);
// Exports
module.exports = exports;
